const enviromentConfig = {
  development: {
    endPoint:
      "https://bk-samngoclinh.meu-solutions.com/ngoclinhscanging/api/v1.0/",
  },
  production: {
    endPoint: "https://bk-samngoclinh.meu-solutions.com/ngoclinhscanging/api/v1.0",
  },
};

export default enviromentConfig;
